/**
 * BACK-15 — um único listener de Esc para todos os overlays: fecha só o do topo, com as mesmas
 * regras do voltar (guarda, não dispensável). Fase de bolha em `window`, para que um controle
 * interno que usa Esc para outra coisa possa `preventDefault()` antes.
 */
import { overlayManager, type OverlayManager } from './overlayManager'

/** Devolve true quando o Esc foi consumido pela pilha. */
export const handleOverlayEscape = (manager: OverlayManager, event: KeyboardEvent): boolean => {
  if (event.key !== 'Escape' || event.defaultPrevented || event.isComposing) return false
  const top = manager.peekTop()
  if (!top || top.options.closeOnEscape === false) return false
  event.preventDefault()
  void manager.requestCloseTop('escape')
  return true
}

const installed = new WeakSet<OverlayManager>()

/** Instala o listener (idempotente por gerenciador; fica pela vida do módulo). */
export const ensureOverlayKeyboard = (manager: OverlayManager = overlayManager): void => {
  if (typeof window === 'undefined' || installed.has(manager)) return
  installed.add(manager)
  window.addEventListener('keydown', (event) => {
    handleOverlayEscape(manager, event)
  })
}
